import { render, staticRenderFns } from "./CorporateFeatureInfoLabel.vue?vue&type=template&id=ffa928e6&"
import script from "./CorporateFeatureInfoLabel.vue?vue&type=script&lang=js&"
export * from "./CorporateFeatureInfoLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports